<template>
    <div class="assignment-state">
        <div
            class="apprentice-tab-buttons"
            v-if="!$authUser.isStudent()">
            <design-2021-apprentice-multiselect-component
                class="project-switcher with-border"
                id="select-project"
                v-if="!$authUser.isStudent()"
                v-model="selectedProject"
                label="title"
                track-by="id"
                :options="groupIn.projects"
                :multiple-select="false"
                @input="redirectToNewProject()">
            </design-2021-apprentice-multiselect-component>

            <b-button
                class="btn-danger-icon-only btn-reopen-assignment"
                id="btn-reopen"
                v-if="closed"
                v-b-modal="'close-projects-modal'"
                v-b-tooltip.hover
                variant="danger"
                :title="$t('internship.open_paper')">
                <i class="fa fa-fw fa-lock"></i>
            </b-button>
            <b-button
                id="btn-closed"
                v-if="!closed"
                v-b-tooltip.hover
                :variant="closing ? 'danger' : 'success'"
                :class="
                    closing
                        ? 'btn-warning-icon-only btn-close-assignment'
                        : 'btn-success-icon-only btn-close-assignment'
                "
                @click.event.prevent.stop="openCloseProject"
                :title="$t('internship.close_internship_report')">
                <i class="fa fa-fw fa-unlock"></i>
            </b-button>
        </div>
        <div v-else>
            <b-button
                class="btn-danger-icon-only btn-student-close-assignment-status"
                v-if="closed"
                v-b-tooltip.hover
                variant="danger"
                :title="$t('internship.paper_closed')">
                <i class="fa fa-fw fa-lock"></i>
            </b-button>
        </div>

        <design-2021-close-projects-modal-component
            :deadline-in="this.project.closes_at"
            ref="close-projects-modal"
            @remove="removeDeadline"
            @close="updateDeadline($event)">
        </design-2021-close-projects-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internship-report-show-open-close-component',
    props: ['projectIn', 'groupIn'],
    data() {
        return {
            selectedProject: this.projectIn,
            project: this.projectIn,
        };
    },
    computed: {
        closed() {
            if (this.project.closes_at) {
                const closeDate = new Date(this.project.closes_at).getTime();
                const nowDate = new Date().getTime();

                return closeDate < nowDate;
            } else {
                return false;
            }
        },
        closing() {
            return !this.closed && !!this.project.closes_at;
        },
    },
    methods: {
        removeDeadline() {
            this.alert
                .confirm(
                    this.$t('internship.delete_deadline'),
                    this.$t('internship.are_you_sure_you_want_to_delete_the_deadline_for_this_project'),
                    this.$t('common.yes'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.setProjectDeadline(this.projectIn.id)).then(
                        (response) => {
                            this.project.closes_at = null;
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.confirm(title);
                        },
                    );
                });
        },
        updateDeadline(deadline) {
            let dateTime = new Date(deadline);
            let date = `${dateTime.getFullYear()}-${String(dateTime.getMonth() + 1).padStart(2, '0')}-${String(dateTime.getDate()).padStart(2, '0')}`;
            let time = `${String(dateTime.getHours()).padStart(2, '0')}:${String(dateTime.getMinutes()).padStart(2, '0')}`;
            this.alert
                .confirm(
                    this.$t('internship.set_deadline'),
                    this.$t('internship.are_you_sure_you_want_to_close_this_specific_project_on', {
                        date: date,
                        time: time,
                    }),
                    this.$t('common.yes'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();

                    let data = {
                        deadline: deadline,
                    };

                    this.axios.post(this.routes.setProjectDeadline(this.projectIn.id), data).then(
                        (response) => {
                            this.alert.success();
                            this.project.closes_at = response.data;
                        },
                        (error) => {
                            this.alert.confirm(title);
                        },
                    );
                });
        },

        redirectToNewProject() {
            window.location = this.routes.studentInternshipShow(this.selectedProject.id);
        },
    },
};
</script>

<style scoped lang="scss">
div.apprentice-tab-buttons {
    align-self: center;

    .btn {
        font-size: $base-font-size;

        &:not(.disabled) {
            i {
                font-size: $base-font-size;
                line-height: 1;
            }
        }
    }
}
</style>
